if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.currentIndex = 0;
        this.mediaItems = [];
        this.dots = [];
      }

      connectedCallback() {
        this.prevButton = this.querySelector('[data-product-modal-prev]');
        this.nextButton = this.querySelector('[data-product-modal-next]');
        this.dots = Array.from(this.querySelectorAll('[data-product-modal-dot]'));
        this.closeButton = this.querySelector('[id^="ModalClose-"]');

        /*
          Important:
          Dawn's global ModalDialog closes media modals on pointerup
          unless the click is inside deferred-media/product-model.
          Our custom arrows/dots are outside those elements, so we must stop
          pointerup from bubbling to ModalDialog.
        */
        [this.prevButton, this.nextButton, this.closeButton, ...this.dots]
          .filter(Boolean)
          .forEach((control) => {
            control.addEventListener('pointerup', (event) => {
              event.stopPropagation();
            });

            control.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
            });
          });

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => {
            this.setActiveMediaByIndex(this.currentIndex - 1);
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => {
            this.setActiveMediaByIndex(this.currentIndex + 1);
          });
        }

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const visibleDots = this.getVisibleDots();
            const index = visibleDots.indexOf(dot);
            this.setActiveMediaByIndex(index >= 0 ? index : 0);
          });
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            event.stopPropagation();
            this.setActiveMediaByIndex(this.currentIndex - 1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            event.stopPropagation();
            this.setActiveMediaByIndex(this.currentIndex + 1);
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(opener);
      }

      getMediaItems() {
        return Array.from(
          this.querySelectorAll('.product-media-modal__content > [data-media-id]:not([hidden])')
        );
      }

      getVisibleDots() {
        return Array.from(this.querySelectorAll('[data-product-modal-dot]:not([hidden])'));
      }

      showActiveMedia(opener = this.openedBy) {
        this.mediaItems = this.getMediaItems();
        this.dots = this.getVisibleDots();

        const openedMediaId = opener ? opener.getAttribute('data-media-id') : null;
        const openedIndex = this.mediaItems.findIndex((element) => element.dataset.mediaId === openedMediaId);

        this.setActiveMediaByIndex(openedIndex >= 0 ? openedIndex : 0);
      }

      setActiveMediaByIndex(index) {
        this.mediaItems = this.getMediaItems();
        this.dots = this.getVisibleDots();

        if (!this.mediaItems.length) return;

        if (index < 0) {
          index = this.mediaItems.length - 1;
        }

        if (index >= this.mediaItems.length) {
          index = 0;
        }

        this.currentIndex = index;

        this.mediaItems.forEach((element, elementIndex) => {
          element.classList.toggle('active', elementIndex === this.currentIndex);
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === this.currentIndex;
          dot.classList.toggle('is-active', isActive);

          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });

        const activeMedia = this.mediaItems[this.currentIndex];

        if (activeMedia && activeMedia.nodeName === 'DEFERRED-MEDIA') {
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

          if (activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
            activeMedia.loadContent();
          }
        }
      }
    }
  );
}